import { type ReactNode } from 'react';
import { type usePhotoUpload } from '@/components/onboarding/use-photo-upload';
import { Caption, FileInput, PhotoTrigger } from './verification-upload-parts';
import { IgUsernameInput } from './verification-ig-input';
import { type IgInputForm } from './use-ig-input';
import type { Lock } from '../hooks/use-verification-lock';

type Ph = ReturnType<typeof usePhotoUpload>;

type Props = {
  ph: Ph;
  disabled: boolean;
  inputRef: React.RefObject<HTMLInputElement | null>;
  open: () => void;
  ig: IgInputForm;
  lock: Lock;
};

export function VerificationFields(p: Props): ReactNode {
  return (
    <>
      <PhotoTrigger
        preview={p.ph.preview}
        disabled={p.disabled}
        onClick={p.open}
        lockedUrl={p.lock.photoLocked ? p.lock.photoUrl : null}
      />
      <Caption mode={p.lock.mode} />
      <IgUsernameInput
        value={p.lock.igLocked ? p.lock.lockedIg : p.ig.value}
        onChange={p.ig.onChange}
        error={p.ig.error}
        disabled={p.disabled}
        locked={p.lock.igLocked}
      />
      <FileInput inputRef={p.inputRef} pick={p.ph.pick} />
    </>
  );
}
